<template>
<div>

  <div v-if="isLoad==false" class="col 12">
    <loading-block  :loading="!isLoad"/>
    <h2>{{ LoadMessage}}</h2>
  </div>
  <div v-if="isLoad"   v-for="(question,question_key) in service.form_setting"
       :key="question_key">
    <div class="col-12">
      <p class="text-center"><b>{{ question.question}}</b></p>
    </div>




    <div   :class="{' alert alert-danger':(question.name && err_field && err_field.includes(question.name)),'':!(question.name && err_field && err_field.includes(question.name))}">


      <div class="  form-group">
        <input type="numeric" @change="recalcPrice()" v-if="question.type=='number'" min="1" class="col-12 form-control" v-model="custom_form[question.name]"    >
        <input type="file" class="form-control" accept="image/*" @change="uploadImageItem($event,question.name)"  v-if="question.type=='image'"  >

        <input type="file" class="form-control"   @change="uploadFileItem($event,question.name)"  v-if="question.type=='file'"  >
        <p v-if="question.type=='file' && file_form[question.name] && file_form[question.name].file &&  file_form[question.name].file.url"><a :href="file_form[question.name].file.url" target="_blank">{{ file_form[question.name].file.name }}</a></p>
         <select @change="recalcPrice()" v-if="question.type=='select' && question.text_options && Object.keys(question.text_options).length>0" class="col-12 form-control" v-model="custom_form[question.name]" >
          <option v-for="(option,option_key) in question.text_options"
               :value="option_key"   :key="option_key">{{ option}}</option>
        </select>
        <select @change="recalcPrice()" v-if="question.type=='multiselect' && question.text_options && Object.keys(question.text_options).length>0" class=" multi_select col-12 form-control" multiple
            v-model="custom_form[question.name]" >
          <option v-for="(option,option_key) in question.text_options"
              :value="option_key"   :key="option_key">{{ option}}</option>
        </select>
        <div class="row" v-if="question.type=='location'">

          <div class="col-10">
            <ol v-if="custom_form[question.name] && custom_form[question.name].data && custom_form[question.name].data.addrs && custom_form[question.name].data.addrs.length>0">
              <li v-for="(addr,addr_key) in custom_form[question.name].data.addrs" :key="addr_key">
                {{ addr.title }}

              </li>
            </ol>
          </div>
          <div class="col-10">

            <input  type="text" class="col-12 form-control" v-model="map_data[question.name]" placeholder="Введите адрес"    >

          </div>
        <div class="col-2">
          <button class="btn" @click="findAddress(question.name)"><i class="fa fa-search-plus"></i></button>
        </div>
        </div>
        <p v-if="question.type=='image' && file_form[question.name] && file_form[question.name].file &&  file_form[question.name].file.url">
          <br>
          <img class="img img-thumbnail" :src="file_form[question.name].file.url" />

        </p>
        <textarea  v-if="question.type=='text'"   class="col-12 form-control"  v-model="custom_form[question.name]"    ></textarea>
         <input  v-if="question.type=='string'" type="text" class="col-12 form-control"  v-model="custom_form[question.name]"    >
        <div v-if="question.type=='datetime'">
          <div class="alert alert-danger" v-if="is_dateerr">
            <p >{{ is_dateerr_message}} </p>
          </div>
          <p v-if="custom_form[question.name]=='' && service.developers.length>1">
            <select class="form-control" @change="chooseDeveloper" v-if="service.developers.length>0" v-model="date_field['developer_id']">
              <option value=""></option>
              <option v-for="(developer,slot_key) in service.developers" :key="developer_key" :value="developer.last_id">{{ developer.name }}</option>

            </select>
          </p>

          <p v-if="custom_form[question.name]=='' && date_field['developer_id']!=''" class="text-center"><input  v-if="question.type=='datetime'" @change="chooseDate()" type="date" class="col-12 form-control"  v-model="date_field['date']"    ></p>
          <p v-if="custom_form[question.name]=='' && date_field.slots && date_field.slots.length>0" class="text-center">
            <select class="form-control" @change="chooseTime()" v-model="date_field['time']">
              <option v-for="(slot,slot_key) in date_field.slots" :key="slot_key" :value="slot">{{ slot }}</option>
            </select>

          </p>
          <p v-if="!(custom_form[question.name]=='')" class="text-center">Выбранное время {{ custom_form[question.name] }} <button @click="clearDate()"  class="btn"><i class="fa fa-pencil"></i></button></p>
        </div>
      </div>
    </div>





  </div>

  <div class="row d-flex justify-content-center" v-if="isLoad && service && service.skip_search_developer==true">
    <p v-if="service.type_invoice=='one'">К оплате: {{ total_price }} {{ service.currency }}</p>
    <p v-if="service.type_invoice=='every_month'">К оплате: {{ total_price }} {{ service.currency }} каждый месяц</p>
    <p v-if="service.type_invoice=='every_year'">К оплате: {{ total_price }} {{ service.currency }} каждый год</p>
  </div>
</div>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";

export default {
  name: "FormService",
  props: {

    service:Object,
    begin_data:Object,




  },
  components: {LoadingBlock},
  data() {

    var app = this;

    return {
      "isLoad":false,
      "LoadMessage":"Идет загрузка",
      "custom_form":{},
      "file_form":{

      },
      "map_data":{

      },
      "date_field":{
        "developer_id":"",
        "date":"",
        "time":"",
        'slots':[],
      },
      'is_dateerr':false,
      'is_dateerr_message':'',
      'begin_price':0,
      'total_price':0,

      "err_field":[],
    }
  },
  mounted() {
    var app=this;
    if(app.service.skip_search_developer){
      app.begin_price=parseFloat(app.service.sum);
      app.total_price=app.begin_price;
    }
    if(app.service.isform=="1" && app.service.form_setting && app.service.form_setting.length>0){
      var custom_form={};
      var map_data={};





        app.service.form_setting.forEach(function(elem){
          var default_value="";
          if(app.begin_data && Object.keys(app.begin_data).length>0){
           if(app.begin_data[elem.name]  ){
             if(elem.type!="image" && elem.type!="file"){
               default_value=app.begin_data[elem.name];
             }else {
               app.file_form[elem.name]=app.begin_data[elem.name];
             }

           }
          }

          if(elem.type=="location"){
            map_data[elem.name]=default_value;
            custom_form[elem.name]={"data":{"addrs":[]}};
          }else {
            custom_form[elem.name]=default_value;
          }

        });



      app.custom_form=custom_form;
      if(app.begin_data && Object.keys(app.begin_data).length>0){
        app.recalcPrice();
      }
      app.map_data=map_data;
      if(app.service.developers && app.service.developers.length==1){
        app.date_field['developer_id']= app.service.developers[0].last_id;
        app.chooseDeveloperWithValue(app.date_field['developer_id']);
      }
      app.disableLoad();
    }
  },
  methods:{
    clearDate(){
      var app=this;
      var questions= app.service.form_setting.filter((question) => question.type=='datetime');
      if(questions[0]) {
        app.date_field.date  = "";
        app.date_field.time  = "";
        app.date_field.slots = [];
        app.custom_form[questions[0].name]="";
      }

    },
    chooseTime(){
      var app=this;
      var questions= app.service.form_setting.filter((question) => question.type=='datetime');
      if(questions[0]){
        app.custom_form[questions[0].name]=app.date_field['date']+" "+app.date_field['time'];
      }
    },
    chooseDeveloper(){
      var app=this;
      var questions= app.service.form_setting.filter((question) => question.type=='datetime');
      if(questions[0]) {
        app.date_field.date  = "";
        app.date_field.time  = "";
        app.date_field.slots = [];
        app.custom_form[questions[0].name]="";
        app.custom_form[questions[0].name+'_developer_id']=app.date_field.developer_id;
      }
    },
    chooseDeveloperWithValue(developer_id){
      var app=this;
      var questions= app.service.form_setting.filter((question) => question.type=='datetime');
      if(questions[0]) {
        app.date_field.date  = "";
        app.date_field.time  = "";
        app.date_field.slots = [];
        app.custom_form[questions[0].name]="";
        app.custom_form[questions[0].name+'_developer_id']=developer_id;
      }
    },
    chooseDate(){
      var app=this;
      var current_date=app.date_field['date'];
      var current_developer_id=app.date_field['developer_id'];
      app.date_field['slots']=[];
      app.is_dateerr=false;
      Api.loadScheduleByService(app.service.last_id,current_date,current_developer_id,function(data){
        app.date_field['slots']=data.slots;
      },function(message){
        app.is_dateerr=true;
        app.is_dateerr_message=message;
      });
    },
    MathParse(str) {
      var el = document.createElement('div');
      el.setAttribute('onclick', "this.result = " + str);
      el.onclick();     // Run script
      return el.result; // Return the result
    },
    recalcPrice(){
    var app=this;
    var total_price=app.begin_price;
    var obj_q_values={};
      app.service.form_setting.forEach(function(question,q_index){
        var current_price=0;
        if (question.type=="select"){
          if(app.custom_form[question.name]){
            var current_name=app.custom_form[question.name];
             current_price=question.filtered_options[current_name];


          }
        }else if(question.type=="multiselect"){
          if(app.custom_form[question.name] && app.custom_form[question.name].length>0){
            app.custom_form[question.name].forEach(function(elem){

              current_price+=parseFloat(question.filtered_options[elem]);

            })
          }
          console.log('multiselect val is' +current_price);
        }else if(question.type=="number"){
          if(app.custom_form[question.name]){
            current_price=app.custom_form[question.name];
          }

        }
        obj_q_values["q"+q_index]=current_price;
      });

 if(app.service.formula_status=="1" && app.service.formula && app.service.formula.length>0){

  var formula=app.service.formula;
  for (const [key, value] of Object.entries(obj_q_values)) {
     formula=formula.replaceAll(key,value);
  }

  var total_price_tmp=app.MathParse(formula);
  total_price_tmp=Math.ceil(total_price_tmp);
  app.total_price=total_price_tmp;
}else {
  app.service.form_setting.forEach(function(question){
    if (question.type=="select"){
      if(app.custom_form[question.name]){
        var current_name=app.custom_form[question.name];
        var current_price=question.filtered_options[current_name];
        total_price+=parseFloat(current_price);

      }
    }else if(question.type=="multiselect"){
      if(app.custom_form[question.name] && app.custom_form[question.name].length>0){
        var current_price=0;
        app.custom_form[question.name].forEach(function(elem){

          current_price+=parseFloat(question.filtered_options[elem]);

        })
        total_price+=parseFloat(current_price);
      }
    }
  });
  app.total_price=total_price;
}

    },
    findAddress(name_field){
        var app=this;
        if(!(app.map_data[name_field])){
          return false;
        }
        var addr=app.map_data[name_field];
        if(addr.length<2){
          return false;
        }
        var custom_form=app.custom_form;
        Api.loadCoordinatesByAddr(addr,function(data){

          // if(!(custom_form[name_field]['data'])){
          //   custom_form[name_field]['data']={};
          // }
          // if(!(custom_form[name_field]['data']['addrs'])){
          //   custom_form[name_field]['data']['addrs']=[];
          // }
          app.map_data[name_field]="";
          custom_form[name_field]['data']['addrs'].push(data.addr);
          app.custom_form=custom_form;
        })
    },
    uploadFileItem(event,name_field){
      var app=this;

      let data = new FormData();
      data.append("file",event.target.files[0]);

      // let config = {
      //   header : {
      //     'Content-Type' : 'image/png'
      //   }
      // }
      app.setLoad("Загрузка файла...");
      var file_form=app.file_form;
      Api.loadFile(data,function(data){

        app.disableLoad();
        var new_data={};
        new_data["file"]=data.file;
        file_form[name_field]=new_data;
      //  app.newItem.photos.push(data.file.url);

        app.file_form=file_form;

      })
    },
    uploadImageItem(event,name_field){
      var app=this;

      let data = new FormData();
      data.append("image",event.target.files[0]);

      // let config = {
      //   header : {
      //     'Content-Type' : 'image/png'
      //   }
      // }
      var file_form=app.file_form;
      app.setLoad("Загрузка изображения...");

      Api.loadImage(data,function(data){
        app.disableLoad();
        var new_data= {};
        new_data["file"]=data.file;
        file_form[name_field]=new_data;
        file_form[name_field]=data;

        app.file_form=file_form;


        app.disableLoad();


      })
    },
    disableLoad(){
      this.isLoad=true;
    },
    setLoad(message){
      this.isLoad=false;
      this.LoadMessage=message;
    },
    saveForm(){
      var app=this;
      var result={};
      var err_field=[];
      app.service.form_setting.forEach(function(elem){
         if(elem.type!="image" && elem.type!="file" && elem.type!="location"){
          if(!(app.custom_form && app.custom_form[elem.name] && app.custom_form[elem.name].length>0)){


            err_field.push(elem.name);
          }
        }else if(elem.type=="location"){
          if(!(app.custom_form && app.custom_form[elem.name]
              && app.custom_form[elem.name]['data'] && app.custom_form[elem.name]['data']['addrs'] &&
              app.custom_form[elem.name]['data']['addrs'].length>1
          )){
             err_field.push(elem.name);
          }
        } else {
          if(!(app.file_form[elem.name] && app.file_form[elem.name].file  &&  app.file_form[elem.name].file.url)){
            err_field.push(elem.name);
          }
        }


      });

      app.err_field=err_field;
      if(err_field.length==0){
         result=app.custom_form;
         if(Object.entries(app.file_form).length>0){
           for (const [key, value] of Object.entries(app.file_form)) {
             result[key]=value;

           }
         }
          return result;
      }

    },

  }
}
</script>

<style scoped>

</style>